<template>
  <component
    :is="barComponent"
    v-bind="$attrs"
    v-on="$listeners"
  />
</template>

<script>
import { mapGetters } from "vuex";
import AthleteBar from "./AthleteBar";
import ClubBar from "./ClubBar";
import CoachBar from "./CoachBar";
import EmptyBar from "./EmptyBar";
import StickyBar from "@/components/StickyBar";

export default {
    components: {
        StickyBar,
    },

    computed: {
        ...mapGetters("athleteProfile", [
            "isSameAthlete",
            "isApplicableClubStaff",
            "isApplicableCollegeCoach",
        ]),

        barComponent() {
            if (this.isSameAthlete) {
                return AthleteBar;
            } else if (this.isApplicableClubStaff) {
                return ClubBar;
            } else if (this.isApplicableCollegeCoach) {
                return CoachBar;
            }

            return EmptyBar;
        },
    },
};
</script>